module.exports = __webpack_public_path__ + "static/media/assa-minus.9e470f66.svg";